import { get, post } from '../axios'

// 查询消息类型列表
export function query_message_type_list(map) {
  return post(`${process.env.VUE_APP_MESSAGE}/notice/type/list`, map)
}

// 查询消息类型详情
export function query_message_type_detail(map) {
  return get(
    `${process.env.VUE_APP_MESSAGE}/notice/type/${map.messageTypeCode}`
  )
}

// 删除消息类型详情
export function delete_message_type_detail(map) {
  return get(
    `${process.env.VUE_APP_MESSAGE}/notice/type/delete/${map.messageTypeCode}`
  )
}

//编辑消息类型
export function edit_message_type(map) {
  return post(`${process.env.VUE_APP_MESSAGE}/notice/type/edit`, map)
}

// 查询消息类型分组列表
export function query_message_type_group_list(map) {
  return post(`${process.env.VUE_APP_MESSAGE}/notice/type/group/list`, map)
}

// 编辑消息类型分组
export function edit_message_type_group(map) {
  return post(`${process.env.VUE_APP_MESSAGE}/notice/type/group/edit`, map)
}

export function delete_message_type_group(map) {
  return get(
    `${process.env.VUE_APP_MESSAGE}/notice/type/group/delete/${map.groupCode}`
  )
}

// 查询消息列表
export function query_message_list(map) {
  return post(`${process.env.VUE_APP_MESSAGE}/user/notice/list`, map)
}

//标记消息已读
export function read_message(map) {
  return post(`${process.env.VUE_APP_MESSAGE}/user/notice/read`, map)
}

//删除消息
export function delete_message(map) {
  return post(`${process.env.VUE_APP_MESSAGE}/user/notice/delete`, map)
}

// 获取消息类型订阅设置
export function get_message_type_subscribe_setting(typeId) {
  return get(`${process.env.VUE_APP_MESSAGE}/notice/subscribe/${typeId}`)
}

// 修改消息类型订阅设置
export function update_message_type_subscribe_setting(map) {
  return post(`${process.env.VUE_APP_MESSAGE}/notice/subscribe/sub`, map)
}
